import { Location } from "../organisation/Location";
import { Person } from "../person/Person";


export class CrmFieldAgentModel {
  id: number;
  person_id: number;
  person: Person
  location_id: number;
  location: Location

  constructor(props: any) {
    this.id = props.id;
    this.person_id = props.person_id;
    this.person = props.person && Person.buildCRMPerson(props.person);
    this.location_id = props.location_id;
    this.location =  props.location && Location.build(props.location);
  }

  name() {
    return this.person.getFullName()
  }

  static create(data: any): CrmFieldAgentModel{
    return new CrmFieldAgentModel(data);
  }
}
